module.exports = __webpack_public_path__ + "static/media/logo_light.1baeaa3e.svg";